import { AppShell, Text } from '@mantine/core';
import classes from "./AppLayout.module.css";
import { Head, usePage } from '@inertiajs/react';
import { Header } from '.';
import { useTranslation } from 'react-i18next';

export default function ({ children, headerProps = {}, pageTitle = null, withFooter = true, bottomNav = null }) {

    const { t } = useTranslation();
    const { appName, pageTitle: backendPageTitle = null } = usePage().props;
    const finalPageTitle = backendPageTitle && backendPageTitle.trim() !== '' ? backendPageTitle : pageTitle;

    return (
        <>
            <Head title={`${finalPageTitle ?? ''} - ${appName}`} />
            <AppShell
                className={classes.layout}
                header={{ height: { base: 64, sm: 50, md: 60, lg: 70 } }}
                footer={bottomNav ? { height: { base: 88, sm: 0 } } : undefined}
            >
                <AppShell.Header>
                    <Header {...headerProps} />
                </AppShell.Header>
                <AppShell.Main>
                    {children}

                    {withFooter && (
                        <Text ta="center" py="xl" fz={{ base: 14, sm: 'md' }} c={{ base: 'gray.7', sm: 'figma-grey.4' }}>
                            {t('layout.needHelp')} <Text span fz={{ base: 14, sm: 'md' }} td={{ base: 'none', sm: 'underline' }} className={classes.footerContactUs} component="a" href="mailto:clients@smartico.one">{t('layout.contactUs')}</Text>
                        </Text>
                    )}
                </AppShell.Main>

                {bottomNav && (
                    <AppShell.Footer withBorder={false} hiddenFrom="sm" className={classes.bottomNav}>
                        {bottomNav}
                    </AppShell.Footer>
                )}
            </AppShell>
        </>
    )
}